import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'types/types';

export default function Logo() {
  const { toggle } = useSelector((state: RootState) => state.applicationState);
  return (
    <div className="header-logo">
      <Box className={`logo-main add-transition logo-state-${toggle}`}>
        <Box className="logo-element"></Box>
        <Box className="logo-element-reailize"></Box>
      </Box>
    </div>
  );
}
